import { InMemoryCache } from '@apollo/client'
import { relayStylePagination } from '@apollo/client/utilities'

// https://www.apollographql.com/docs/react/caching/overview/
export const inMemoryCache = new InMemoryCache({
  /* keyArgs define what attributes warrant a seperate instance
     of the query in the cache. Default is all variables present in the query. */
  typePolicies: {
    Query: {
      fields: {
        threadViews: {
          keyArgs: ['id', 'q'],
        },
        thread: {
          keyArgs: ['id'],
        },
        allDynamicColumns: {
          keyArgs: ['moduleName', 'enabled'],
        },
        userActivityDayReport: {
          keyArgs: ['user', 'date'],
        },
        report: {
          keyArgs: ['user', 'dateStart', 'dateEnd', 'weekPartitions'],
        },
        driverActivityPeriodReport: {
          keyArgs: [
            'user',
            'dateStart',
            'dateEnd',
            'weekPartitions',
            'weekPartitions',
            'useWorkDayReport',
          ],
        },
        allUsers: relayStylePagination([
          'q',
          'orderBy',
          'dropdown',
          'includeInactive',
          'includeExpiredDocuments',
          'onlyIncludeUserDocumentCategories',
          'filterLeaderGroup',
        ]),
        allUserDocumentCategories: {
          keyArgs: ['includeExpiredDocuments'],
        },
        allManualEntries: relayStylePagination(),
        allUserExports: relayStylePagination(),
        allFilledOutForms: relayStylePagination(),
        allThreads: relayStylePagination([
          'sticky',
          'q',
          'orderBy',
          'leaderGroupId',
          'visibility',
        ]),
        myAppNotifications: relayStylePagination(),
        allInfringements: relayStylePagination([
          'users',
          'company',
          'infringementCategory',
        ]),
        allUsersInfringementsSums: relayStylePagination(['users']),
        allIssues: relayStylePagination([
          'company',
          'user',
          'includeSeverities',
        ]),
        allRoutePlans: relayStylePagination(),
        allChecklists: relayStylePagination([
          'user',
          'active',
          'mandatoryOnly',
        ]),
        monthReport: {
          keyArgs: ['user', 'datetimeStart', 'datetimeEnd', 'year', 'month'],
        },
        allWorkPeriods: {
          keyArgs: ['user', 'datetimeStart', 'datetimeEnd'],
        },
        allTachoDriverFiles: relayStylePagination(['q', 'processed']),
        allAbsences: relayStylePagination([
          'users',
          'absenceType',
          'requestStatus',
          'leaderGroup',
          'datetimeStart_Lt',
          'datetimeStart_Gte',
          'datetimeStart_Lte',
          'datetimeEnd_Gte',
          'createdAt_Gte',
          'createdAt_Lte',
          'orderBy',
        ]),
      },
    },
    ThreadViewNode: {
      fields: {
        // We define pagination for nested pagination queries here.
        notSeenBy: relayStylePagination(['q', 'unseenFirst', 'unseenAfter']),
        seenBy: relayStylePagination(['q', 'seenFirst', 'seenAfter']),
      },
    },
    ThreadNode: {
      fields: {
        posts: relayStylePagination(),
      },
    },
    DriverActivityReport: {
      keyFields: ['user', 'startDate', 'endDate'],
    },
    OvertimeSum: {
      keyFields: false,
    },
    // These are nested value rows under monthReport (never fetched standalone by
    // id). They carry an `id` field, so Apollo would normalize them by default and
    // non-unique/reused ids collide across users/months. Treat them as embedded.
    WorkPeriodGroup: {
      keyFields: false,
    },
    SalaryCodeSums: {
      keyFields: false,
    },
    SalaryCodeSumsWithDepartment: {
      keyFields: false,
    },
    SalaryCodeSumsFloat: {
      keyFields: false,
    },
    UserNode: {
      keyFields: ['id'],
    },
    DriverDietNode: {
      keyFields: ['id'],
    },
    SalaryDayNode: {
      keyFields: ['id'],
    },
    WorkPeriodNode: {
      keyFields: ['id'],
    },
    CalendarItemNode: {
      keyFields: ['id'],
    },
    AbsenceNode: {
      keyFields: ['id'],
      fields: {
        comments: relayStylePagination(),
      },
    },
  },
})
